import { render, staticRenderFns } from "./PatternModalHeader.vue?vue&type=template&id=4e2e24af&scoped=true&"
import script from "./PatternModalHeader.vue?vue&type=script&lang=js&"
export * from "./PatternModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./PatternModalHeader.vue?vue&type=style&index=0&id=4e2e24af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e24af",
  null
  
)

export default component.exports